export const mainCardData = [
  {
    type: "hyphen",
    background: "#da291c12",
    header: "What’s excluded?",
    content: [
      "First-party losses: Direct financial loss and loss of business income suffered by the business itself.",
      "Product failure and product recall.",
      "Fines, penalties and punitive damages.",
      "Insolvency.",
      "Investment advice or performance.",
      "Sexual harassment, abuse and misconduct.",
      "Racism and hate speech.",
    ],
  }
];

export const accordion1Data = {
  header:
    "Far broader than the name cyber implies, our policy extends to cover numerous incidents including but not limited to:",
  content: [
    {
      title: "Cyber extortion and malware",
      answer: "(viruses, ransomware, or publishing of stolen data)",
    },
    {
      title: "Denial of service",
      answer: "(disruption to operations)",
    },
    {
      title: "Downstream attack",
      answer:
        "(a compromise of your environment resulting in damages to others)",
    },
    {
      title: "Hacking",

      answer: "",
    },
    {
      title: "Insider and privilege misuse",

      answer: "(both devices and physical hard copy data).",
    },

    {
      title: "Physical theft and loss",

      answer: "Data breach protection ",
    },
    {
      title: "Threats posed by third party access into a client environment",

      answer: "",
    },
  ],
};

export const accordion2Data = {
  header:
    "Our comprehensive cyber insurance policy provides the following coverages:",
  section: [
    {
      header: "1st party",
      content: [
        {
          title: "Regulatory fines",
          answer:
            "To the extent insurable by law, fines imposed by a government regulatory body due to an information privacy breach",
        },
        {
          title: "Business interruption",
          answer:
            "Loss of income and increased cost of working because of a systems security incident.",
        },
        {
          title: "Data restoration",
          answer:
            "Costs to restore, re-collect or replace data lost, stolen or corrupted due to a systems security incident",
        },
      ],
    },
    {
      header: "2nd party",
      content: [
        {
          title: "Privacy liability",
          answer:
            "Defence and settlement of liability claims arising from compromised information.",
        },
        {
          title: "Network security liability",
          answer:
            "Defence and settlement of liability claims resulting from a system security incident affecting systems and data as well as causing harm to third-party systems and data.",
        },
        {
          title: "Media liability",
          answer:
            "Defence and settlement of liability claims resulting from disseminated content (including social media content) including:",
          subAnswer: [
            "Defamation",
            "Unintentional copyright infringement",
            "Unintentional infringement of right to privacy.",
          ],
        },
      ],
    },
    {
      header: "incident response",
      content: [
        {
          title: "Incident response costs",
          answer: "Costs to respond to a system’s security incident, including",
          subAnswer: [
            "to obtain professional (legal, public relations and IT forensics) advice, including assistance in managing the incident, co-ordinating response activities, making representation to regulatory bodies and coordination with law enforcement",
            "to perform incident triage and forensic investigations, including IT experts to confirm and determine the cause of the incident, the extent of the damage including the nature and volume of data compromised, how to contain, mitigate and repair the damage, and guidance on measures to prevent reoccurrence",
            "for crisis communications and public relations costs to manage a reputational crisis, including spokesperson training and social media monitoring",
            "for communications to notify affected parties",
            "for remediation services such as credit and identity theft monitoring to protect affected parties from suffering further damages.",
          ],
        },
      ],
    },
  ],
};

export const travelSuperiorPlan = [
  {
    title: "Is Cyber Liability covered?",
    answer:
      "Yes, but the third party liability portion only. Business interruption and forensic costs are not included. Claims for third party data loss and breach of privacy are covered.",
  },
  {
    title: "What about medical malpractice?",
    answer:
      "Incidental medical malpractice (first aid) is included, but we don’t provide Medical Malpractice for healthcare professionals.",
  },
  {
    title: "Are unfair dismissals covered?",
    answer: "Yes.",
  },
  {
    title: "Are workplace vaccine disputes covered?",
    answer:
      "Legal representation costs for a dispute are covered up to the sub-limit of R250 000.",
  },
  {
    title:
      "What about regulatory enquiries, for example, an enquiry brought by the POPIA regulator?",
    answer:
      "The policy will provide the costs for legal representation to assist the insured up to the sub-limit of R250 000.",
  },
  {
    title:
      "If the business must appear before any tribunal or regulatory body for contravening a law, will the policy provide legal defence costs?",
    answer:
      "Yes, up to the sub-limit of R250 000, provided the enquiry or hearing arises directly out of the conduct of the business.",
  },
  {
    title: "Does the iTOO SureThing cover business debts?",
    answer:
      "The SureThing policy does not cover business debts. It covers legal liability arising from a wrongful act on the part of the business – not debts incurred as part of commercial transactions.",
  },
  {
    title:
      "What if my business suffers a loss without there being a liability?",
    answer:
      "SureThing does not cover the business’s own loss, known as a first-party loss. It only covers liability to third parties arising from a wrongful act.",
  },
  {
    title: "What about commercial crime or staff theft?",
    answer:
      "Commercial crime and staff theft are considered first-party losses suffered by the business, not a third-party liability. As such, the SureThing policy does not cover it.",
  },
  {
    title: "Is Product Inefficacy and Product Recall covered?",
    answer:
      "If your product does not do what it is supposed to or fails, and a pure financial loss is caused, there is no cover. Product recall is also not covered.",
  },
  {
    title: "What about the renewal of the policy?",
    answer:
      "The policy auto-renew each year at the same policy terms and conditions, unless there is a claim, or the business no longer falls within the criteria and does not qualify for the policy. An inflationary increase in premium may be applied on 30 days’ notice.",
  },
  {
    title: "Need more cover than SureThing can provide?",
    answer:
      "No problem! Whatever the shape and size of your business, if you need indemnity that exceeds the SureThing policy limits, simply ask your broker or get in touch with us directly for a list of our product offerings. If you need it covered, we have the policy to do it.",
  },
];

export const productDet = [
  {
    header:
      "Far broader than the name cyber implies, our policy extends to cover numerous incidents including but not limited to:",
    content: [
      {
        title: "Cyber extortion and malware",
        answer: "(viruses, ransomware, or publishing of stolen data)",
      },
      {
        title: "Denial of service",
        answer: "(disruption to operations)",
      },
      {
        title: "Downstream attack",
        answer:
          "(a compromise of your environment resulting in damages to others)",
      },
      {
        title: "Hacking",
        answer: "",
      },
      {
        title: "Insider and privilege misuse",
        answer: "(both devices and physical hard copy data).",
      },

      {
        title: "Physical theft and loss",
        answer: "Data breach protection ",
      },
      {
        title: "Threats posed by third party access into a client environment",
        answer: "",
      },
    ],
  },
  {
    header: "Payment options",
    content: "Annual or Monthly",
  },
  {
    header: "Benefits",
    content: "Benefit limits from R250 000 to R10 000 000 available",
  },
  {
    header: "Benefits table to be read in conjunction with your policy wording",
    content:
      "The information below is only a summary of the cover you have under your Cyber insurance policy and is provide to you for easy reference. Kindly refer to your policy wording for the full list of terms and conditions.",
  },
];
